/**
 * recuperation du breakpoint en px
 */
// breakpoint definis en CSS
let breakpoint = {
    xs: 478,
    sm: 767,
    md: 991,
    lg: 1399
};

export function getBreakpoint(id) {
    return breakpoint[id]
}



/**
 * Prevention du scroll
 */
let scrollTop;
export function preventScroll(bool) {
    const $html = document.documentElement;
    const $body = document.body;

    if (bool) {
        scrollTop = $html.scrollTop;
        // la class no-scroll donne la hauteur à 100% donc pour eviter que l'on se retrouve en debut de page
        // on recupere la valeur de scroll du body qu'on repercute sur le inner
        $html.classList.add('no-scroll');
        $body.classList.add('no-scroll');
    } else {
        $html.classList.remove('no-scroll');
        $body.classList.remove('no-scroll');

        window.scrollTo({top: scrollTop, left:0, behavior: 'auto'})
    }
}



/**
 * Recuperation des elements parents
 */
export function getParents(el, parentSelector /* optional */) {

    // If no parentSelector defined will bubble up all the way to *document*
    if (parentSelector === undefined) {
        parentSelector = document;
    }

    var parents = [];
    var p = el.parentNode;

    while (p !== parentSelector) {
        var o = p;
        parents.push(o);
        p = o.parentNode;
    }
    parents.push(parentSelector); // Push that parentSelector you wanted to stop at
    
    return parents;
}